import { render } from "./VisitorCheckInsAndLogsHeader.vue?vue&type=template&id=18ca9834"
import script from "./VisitorCheckInsAndLogsHeader.vue?vue&type=script&lang=js"
export * from "./VisitorCheckInsAndLogsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__